import { render, staticRenderFns } from "./Relearn.vue?vue&type=template&id=487d9fcc&"
import script from "./Relearn.vue?vue&type=script&lang=ts&"
export * from "./Relearn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports